import reducer from './view';
import { actionCreators, ViewActionType } from './view.actionCreators';
import * as actionTypes from './view.actionTypes';

export * from './view';
export * from './view.selectors';
export type ActionType = ViewActionType;
export { actionTypes, actionCreators };
export default reducer;
